import useScheduleStore from "@/store/schedule";
import { Button, Card, Group, Stack, Text } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

export default function ScheduleFooter() {
  const { selectedDate, setDate } = useScheduleStore();
  const goNext = () => {
    setDate({
      selectedDate: new Date(
        new Date(selectedDate).setDate(new Date(selectedDate).getDate() + 1)
      ),
    });
  };
  const goPrev = () => {
    setDate({
      selectedDate: new Date(
        new Date(selectedDate).setDate(new Date(selectedDate).getDate() - 1)
      ),
    });
  };
  const goToday = () => {
    setDate({
      selectedDate: new Date(),
    });
  };

  const isToday =
    new Date().getDate() === new Date(new Date(selectedDate))?.getDate();
  return (
    <>
      <Stack p="0" h="60px" id="day-handler">
        <Card shadow="xs" p="sm" py="5" mx="xs" my="xs" h="100%">
          <Group justify="space-between" align="center" pt="5">
            <Button
              size="compact-xs"
              color="gray"
              onClick={goPrev}
              variant="light"
            >
              <Group gap="5">
                <IconChevronRight size={15} />
                <Text size="xs">روز قبل</Text>
              </Group>
            </Button>

            {!isToday && (
              <Button
                size="compact-xs"
                color="gray"
                onClick={goToday}
                variant="light"
              >
                <Text size="xs">برو به امروز</Text>
              </Button>
            )}
            <Button
              size="compact-xs"
              color="gray"
              onClick={goNext}
              variant="light"
            >
              <Group gap="5">
                <Text size="xs">روز بعد</Text>
                <IconChevronLeft size={15} />
              </Group>
            </Button>
          </Group>
        </Card>
      </Stack>
    </>
  );
}
